export default {
    state    : () => ({
        file_src: ''
    }),
    mutations: {
        SET_FILE_SRC(state, src) {
            state.file_src = src;
        }
    },
    actions  : {
        SET_POLICY_FILE(context, payload) {
            context.commit('SET_FILE_SRC', payload);
        }
    },
}